
import React from "react";
import { useNavigate } from "react-router-dom";
import { intl } from "LocaleWrapper";
import { Button } from "@cofano/cck";
import { Box, Typography, Container } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import Helmet from "components/helmet/Helmet";

const PageNotFound = () => {
	const navigate = useNavigate();

	return (
		<React.Fragment>
			<Helmet title={intl.formatMessage({ id: "PAGE_NOT_FOUND" })} />

			<Container maxWidth="md">
				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						justifyContent: "center",
						minHeight: "70vh",
						textAlign: "center",
						gap: 3,
					}}>
					<ErrorOutlineIcon sx={{ fontSize: 100, color: "text.primary" }} />

					<Box>
						<Typography
							variant="h4"
							component="h1"
							sx={{ color: "text.primary", fontWeight: 700, mb: 1 }}>
							{intl.formatMessage({ id: "PAGE_NOT_FOUND" })}
						</Typography>

						<Typography variant="body1" color="text.secondary" sx={{ fontSize: 18 }}>
							{intl.formatMessage({ id: "REQUESTED_PAGE_NOT_FOUND" })}
						</Typography>
					</Box>

					<Button onClick={() => navigate("/")}>
						{intl.formatMessage({ id: "BACK_TO_HOME" })}
					</Button>
				</Box>
			</Container>
		</React.Fragment>
	);
};

export default PageNotFound;
